import { getMapByEmailHashOrUsername } from '@/services/actions';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { hashEmail } from '@utils/crypto';
import { handleError } from '@utils/errors';

export const useEmailMap = (email?: string) => {
  const queryClient = useQueryClient();
  const queryKey = ['emailMap', email ?? 'dummy'];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => getMapByEmailHashOrUsername({ emailHash: email ? hashEmail(email) : 'dummy' }),
    onError: handleError,
  });

  const handleRemoveMap = () => {
    queryClient.removeQueries({ queryKey, exact: true });
  };

  return { map: data, handleRemoveMap, isLoading };
};
